import type {
	CategorizedQueueData,
	CategorizedQueueRestItem,
	CategorizedQueueRestData,
} from '../types.tsx';

export const transformRestData = (
	{ categories }: CategorizedQueueRestData,
	projectKey: string,
): CategorizedQueueData =>
	// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type 'CategorizedQueueRestItem' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	categories.reduce<Record<string, any>>(
		// @ts-expect-error(PARTIAL_RECORD) TS2345 - Argument of type '(acc: CategorizedQueueData, { key, queues, ...rest }: CategorizedQueueRestItem) => CategorizedQueueData & { [x: string]: { queues: { category: ItsmPractice; count: undefined; projectKey: string; lastRefreshedTime: number; ... 9 more ...; canBeHidden?: boolean | undefined; }[]; iconUrl: string; name: string; order: n...' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: CategorizedQueueRestItem, currentIndex: number, array: CategorizedQueueRestItem[]) => Record<...>'.
		(acc: CategorizedQueueData, { key, queues, ...rest }: CategorizedQueueRestItem) =>
			Object.assign(acc, {
				[key]: {
					...rest,
					queues: queues.map((queue) => ({
						...queue,
						category: key,
						// We unset the count as the API end-point will always return 0 and we want
						// to differentiate between no count data and 0 count.
						// Count data is provided by nav-items end point.
						count: undefined,
						// Project key is sent as '_UNUSED' by the end-point. We populate it here
						// so we can have a complete data set
						projectKey,
						lastRefreshedTime: 0,
						shouldSkipIssueCountRefresh: false,
					})),
				},
			}),
		{},
	);
